export default __webpack_public_path__ + "img/my-data.199dca.svg";